<footer *ngIf="isSmallView" class="mobile-footer">
  <div class="footer-content">
    <div class="footer-content-communities" *ngIf="communities.length > 0">
      <div class="footerlogo">
        <img rel="preload" alt="Logo" src="assets/custom/image/AppLogo.png" />
      </div>
      <div class="footer-communities">
        <div class="footer-communities-content">
          <ng-container *ngFor="let community of communities">
            <a class="footer-communities-svg" [inlineSVG]="community.image"
              (click)="openExternalUrl(community.url)"></a>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="footer-content-paymentoptions">
      <div class="footerlogo" *ngIf="communities.length === 0">
        <img rel="preload" alt="Logo" src="assets/custom/image/AppLogo.png" />
      </div>
      <div class="footer-payments" *ngIf="paymentoptions.length > 0">
        <div class="footer-content-title" langkey="phMainNav_Paymentoptions"></div>
        <div class="payments-methods">
          <ng-container *ngFor="let paymentoption of paymentoptions">
            <a class="payments-svg" [inlineSVG]="paymentoption.image"></a>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="footer-content-service">
      <div class="footer-content-title" langkey="phMainNav_Service"></div>
      <div class="footer-nav">
        <ul>
          <li>
            <a class="accessibiltybutton" a11y_Button (click)="openAccessibiltyDialog()">
              <div class="inline-icon" inlineSVG="hypersoft-accessibilty.svg"></div>
              <span langkey="phA11YDialog_Headline"></span>
              <div *ngIf="isAccessibilityModeActive" class="a11y-check-small">
                <div class="inline-icon a11y-check-svg" inlineSVG="shop-icons.svg#ya-done">
                </div>
              </div>
            </a>
          </li>
          <ng-container>
            <li>
              <a class="cookiebutton" a11y_Button (click)="openCookieDialog()">
                <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-cookie"></div><span
                  langkey="phCookie_Cookie"></span>
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
      <div class="language-content">
        <div class="footer-content-title" langkey="phMainNav_Language"></div>
        <div class="languages">
          <div *ngIf="canSelectLanguage" class="language-container">
            <a a11y_Button mat-icon-button [ngClass]="['mat-icon-button', 'mainFooter-nav', 'ya-body-1']"
              (click)="openLanguageDialog()">
              <div class="inline-icon ya-language-icon"
                [inlineSVG]="'shop-icons.svg#ya-flag-' + (currentLocale || 'de')"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-content-legal">
      <div class="footer-content-title" langkey="phMainNav_Legal"></div>
      <div *ngIf="isRevokeEnabled" class="footer-revoke-order-link">
        <a class="footer-revoke-order-anchor"
           a11y_Link
           (click)="navigateToRevokeOrder()">
          <div class="inline-icon footer-revoke-order-icon" inlineSVG="shop-icons.svg#ya-undo"></div>
          <span langkey="phRevokeOrder_FooterLink"></span>
        </a>
      </div>
      <div class="footer-nav">
        <ul>
          <ng-container *ngFor="let term of terms">
            <li *ngIf="term.id !== -2"><a a11y_Button (click)="navigateToTerms(term.id)">{{term.label}}</a>
            </li>
          </ng-container>
          <ng-container>
            <li><a a11y_Button (click)="openLicenseDialog()"> <span langkey="phLicense_Licenses"></span>
              </a></li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
  <div class="container">
    <p>© {{now.year()}} {{company_name}} | <span langkey="phMainNav_CopyRight"></span> | {{version}}</p>
  </div>
</footer>
<footer *ngIf="!isSmallView" class="desktop-footer">
  <div class="footer-content">
    <div class="footer-content-communities" *ngIf="communities.length > 0">
      <div class="footerlogo">
        <img rel="preload" alt="Logo" src="assets/custom/image/AppLogo.png" />
      </div>
      <div class="footer-communities">
        <div class="footer-communities-content">
          <ng-container *ngFor="let community of communities">
            <a class="footer-communities-svg" [inlineSVG]="community.image"
              (click)="openExternalUrl(community.url)"></a>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="footer-content-paymentoptions">
      <div class="footerlogo" *ngIf="communities.length === 0">
        <img rel="preload" alt="Logo" src="assets/custom/image/AppLogo.png" />
      </div>
      <div class="footer-payments" *ngIf="paymentoptions.length > 0">
        <div class="footer-content-title" langkey="phMainNav_Paymentoptions"></div>
        <div class="payments-methods">
          <ng-container *ngFor="let paymentoption of paymentoptions">
            <a class="payments-svg" [inlineSVG]="paymentoption.image"></a>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="footer-content-service">
      <div class="footer-content-title" langkey="phMainNav_Service"></div>
      <div class="footer-nav">
        <ul>
          <li>
            <a class="accessibiltybutton" a11y_Button (click)="openAccessibiltyDialog()">
              <div class="inline-icon" inlineSVG="hypersoft-accessibilty.svg"></div>
              <span langkey="phA11YDialog_Headline"></span>
              <div *ngIf="isAccessibilityModeActive" class="a11y-check-small">
                <div class="inline-icon a11y-check-svg" inlineSVG="done.svg">
                </div>
              </div>
            </a>
          </li>
          <ng-container *ngIf="!isMobile">
            <li><a class="cookiebutton" a11y_Button (click)="openCookieDialog()">
                <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-cookie"></div><span
                  langkey="phCookie_Cookie"></span>
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
      <div class="language-content" *ngIf="canSelectLanguage">
        <div class="footer-content-title" langkey="phMainNav_Language"></div>
        <div class="languages">
          <div class="language-container">
            <a a11y_Button mat-icon-button [ngClass]="['mat-icon-button', 'mainFooter-nav', 'ya-body-1']"
              (click)="openLanguageDialog()">
              <div class="inline-icon ya-language-icon"
                [inlineSVG]="'shop-icons.svg#ya-flag-' + (currentLocale || 'de')"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-content-legal">
      <div class="footer-content-title" langkey="phMainNav_Legal"></div>
      <div *ngIf="isRevokeEnabled" class="footer-revoke-order-link">
        <a class="footer-revoke-order-anchor"
           a11y_Link
           (click)="navigateToRevokeOrder()">
          <div class="inline-icon footer-revoke-order-icon" inlineSVG="shop-icons.svg#ya-undo"></div>
          <span langkey="phRevokeOrder_FooterLink"></span>
        </a>
      </div>
      <div class="footer-nav">
        <ul>
          <ng-container *ngFor="let term of terms">
            <li *ngIf="term.id !== -2"><a a11y_Button (click)="navigateToTerms(term.id)">{{term.label}}</a>
            </li>
          </ng-container>
          <ng-container *ngIf="!isMobile">
            <li><a a11y_Button (click)="openLicenseDialog()"> <span langkey="phLicense_Licenses"></span>
              </a></li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="zahlung">
      <p>© {{now.year()}} {{company_name}} | <span langkey="phMainNav_CopyRight"></span> | {{version}}</p>
    </div>

  </div>
</footer>